import angular from 'angular';
import QrCreator from 'qr-creator';
import handleHttpError from '@/shared/services/HandleHttpError';

angular
  .module('cloudX')
  .controller('Enable2FADialog', [
    '$element',
    'resourceFactorySvc',
    'dataCache',
    'flySvc',
    'close',
    'appSettings',
    Enable2FADialog,
  ]);

function Enable2FADialog($element, resourceFactorySvc, dataCache, flySvc, close, appSettings) {
  var vm = this;
  vm.employee = dataCache.getArray('employee');
  vm.showPhoneNumber = !vm.employee.employeeMobilePhone;
  vm.key = undefined;

  vm.data = {
    code: '',
    backupPhone: vm.employee.employeeMobilePhone,
  };

  vm.getDefaultCountry = () => appSettings.defaultCountry;

  resourceFactorySvc.get('user').get2FA(
    null,
    null,
    function(data) {
      vm.key = data.key;
      const appName = `AdminPulse${data.environment === 'prd' ? '' : `${data.environment}`}`;
      const otpUrl = `otpauth://totp/${appName}:${vm.employee.employeeEmail}?secret=` + data.key;
      QrCreator.render(
        {
          text: otpUrl,
          size: 128,
        },
        document.getElementById('qrcode'),
      );
    },
    function(error) {
      handleHttpError(error);
      throw error;
    },
  );

  vm.save = function() {
    vm.saving = true;
    resourceFactorySvc.get('user').enable2FA(
      null,
      vm.data,
      function(e) {
        vm.saving = false;
        flySvc.success('msg2FAEnabled');
        close(true, 500);
        $element.modal('hide');
      },
      function(error) {
        vm.saving = false;
        flySvc.error(error.data.code, error.data.parameters);
      },
    );
  };
  vm.cancel = function() {
    close(null, 500);
  };
}
